/* Compare page (sections/csl-compare.liquid)
   Picks products (predictive search / NEW-page compare tray / ?products=),
   loads /products/<handle>?view=csl-json, builds the side-by-side table and
   optionally asks the configured AI endpoint for a written comparison.       */
(function () {
  'use strict';
  var STORAGE_KEY = 'csl-compare-v1';

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function readStore() { try { var v = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; } }
  function writeStore(list) { try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); } catch (e) { /* ignore */ } }
  function youtubeId(url) {
    if (!url) return '';
    var m = url.match(/(?:youtu\.be\/|v=|\/embed\/|\/shorts\/)([A-Za-z0-9_-]{6,})/);
    return m ? m[1] : '';
  }
  function parseNumber(s) {
    if (!s) return null;
    var m = String(s).replace(/,/g, '').match(/-?\d+(?:\.\d+)?/);
    return m ? parseFloat(m[0]) : null;
  }
  var LOWER_BETTER = /weight|power|consumption|noise|draw|price/i;
  var HIGHER_BETTER = /lumen|lux|output|brightness|cri|life|hours|candela|nit/i;

  function parseDescription(html) {
    var out = { overview: '', bestFor: '', highlights: [], specs: [], sections: {}, notes: [] };
    if (!html) return out;
    var doc;
    try { doc = new DOMParser().parseFromString(html, 'text/html'); } catch (e) { return out; }
    var current = '';
    Array.prototype.forEach.call(doc.body.children, function (node) {
      var tag = node.tagName;
      if (tag === 'P') {
        var strong = node.querySelector('strong, b');
        if (strong) {
          var labelText = strong.textContent.trim();
          var label = labelText.toLowerCase();
          var text = node.textContent.replace(strong.textContent, '').trim();
          current = label;
          if (label.indexOf('overview') === 0) out.overview = text || out.overview;
          else if (label.indexOf('best for') === 0) out.bestFor = text || out.bestFor;
          else if (text) out.sections[labelText.replace(/:$/, '')] = text;
        } else if (node.querySelector('em, i')) {
          out.notes.push(node.textContent.trim());
        } else if (!out.overview && !current) {
          out.overview = node.textContent.trim();
        } else if (current) {
          var k = current.charAt(0).toUpperCase() + current.slice(1);
          out.sections[k] = (out.sections[k] ? out.sections[k] + ' ' : '') + node.textContent.trim();
        }
      } else if (tag === 'UL' || tag === 'OL') {
        var items = Array.prototype.map.call(node.querySelectorAll('li'), function (li) { return li.textContent.replace(/\s+/g, ' ').trim(); }).filter(Boolean);
        if (current.indexOf('highlight') === 0 || current.indexOf('feature') === 0) {
          out.highlights = out.highlights.concat(items);
        } else if (current.indexOf('spec') !== -1 || current.indexOf('technical') !== -1) {
          items.forEach(function (t) {
            var i = t.indexOf(':');
            if (i > 0) out.specs.push([t.slice(0, i).trim(), t.slice(i + 1).trim()]); else out.specs.push([t, '']);
          });
        } else if (current) {
          var key = current.charAt(0).toUpperCase() + current.slice(1);
          out.sections[key] = items.join('; ');
        } else {
          out.highlights = out.highlights.concat(items);
        }
      } else if (tag === 'TABLE') {
        Array.prototype.forEach.call(node.querySelectorAll('tr'), function (tr) {
          var cells = tr.querySelectorAll('th, td');
          if (cells.length >= 2) out.specs.push([cells[0].textContent.trim(), cells[1].textContent.trim()]);
        });
      } else if (tag === 'H2' || tag === 'H3' || tag === 'H4') {
        current = node.textContent.trim().toLowerCase();
      }
    });
    if (!out.overview && !out.highlights.length && !out.specs.length) out.overview = (doc.body.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 400);
    return out;
  }

  function init(root) {
    if (!root || root.dataset.ccReady) return;
    root.dataset.ccReady = '1';
    var max = parseInt(root.dataset.max, 10) || 4;
    var endpoint = (root.dataset.aiEndpoint || '').trim();
    var search = root.querySelector('[data-search]');
    var results = root.querySelector('[data-results]');
    var spinner = root.querySelector('[data-search-spinner]');
    var slots = root.querySelector('[data-slots]');
    var slotTpl = root.querySelector('[data-tpl-slot]');
    var emptyTpl = root.querySelector('[data-tpl-slot-empty]');
    var slotCount = root.querySelector('[data-slot-count]');
    var area = root.querySelector('[data-compare-area]');
    var emptyMsg = root.querySelector('[data-empty]');
    var thead = root.querySelector('[data-thead]');
    var tbody = root.querySelector('[data-tbody]');
    var table = root.querySelector('[data-table]');
    var status = root.querySelector('[data-status]');
    var pickerActions = root.querySelector('[data-picker-actions]');
    var diffOnly = root.querySelector('[data-diff-only]');
    var aiBody = root.querySelector('[data-ai-body]');
    var aiRun = root.querySelector('[data-ai-run]');
    var hint = root.querySelector('[data-hint]');

    var state = { handles: [], products: {}, loading: {} };

    /* ---------- picking ---------- */
    function fromUrl() {
      try {
        var p = new URLSearchParams(location.search).get('products');
        if (p) return p.split(',').map(function (h) { return h.trim(); }).filter(Boolean).slice(0, max);
      } catch (e) { /* ignore */ }
      return null;
    }
    function syncOut() {
      writeStore(state.handles.map(function (h) { var p = state.products[h]; return { handle: h, title: p ? p.title : h }; }));
      try {
        var url = location.pathname + (state.handles.length ? '?products=' + encodeURIComponent(state.handles.join(',')) : '');
        history.replaceState(null, '', url);
      } catch (e) { /* ignore */ }
    }
    function add(handle, seed) {
      if (!handle || state.handles.indexOf(handle) !== -1) return;
      if (state.handles.length >= max) state.handles.shift();
      state.handles.push(handle);
      if (seed && !state.products[handle]) state.products[handle] = Object.assign({ _seed: true }, seed);
      render();
      load(handle);
    }
    function remove(handle) {
      state.handles = state.handles.filter(function (h) { return h !== handle; });
      render();
    }
    function load(handle) {
      if (state.loading[handle] || (state.products[handle] && !state.products[handle]._seed)) return;
      state.loading[handle] = true;
      fetch('/products/' + encodeURIComponent(handle) + '?view=csl-json', { credentials: 'same-origin', headers: { 'Accept': 'application/json, text/plain, */*' } })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (txt) {
          var data = JSON.parse(txt);
          data.parsed = parseDescription(data.description_html);
          data.video_id = youtubeId(data.video_url);
          state.products[handle] = data;
        })
        .catch(function (err) {
          state.products[handle] = Object.assign(state.products[handle] || { handle: handle, title: handle }, { _error: err.message, parsed: { overview: '', bestFor: '', highlights: [], specs: [], sections: {}, notes: [] } });
        })
        .then(function () { state.loading[handle] = false; render(); });
    }

    /* ---------- search ---------- */
    var searchTimer, activeIndex = -1, lastResults = [];
    function closeResults() { if (results) { results.hidden = true; results.innerHTML = ''; } if (search) search.setAttribute('aria-expanded', 'false'); activeIndex = -1; lastResults = []; }
    function renderResults(list, q) {
      if (!results) return;
      lastResults = list;
      results.innerHTML = '';
      if (!list.length) {
        results.innerHTML = '<li class="cc-results__msg">No products match “' + esc(q) + '”.</li>';
      } else {
        list.forEach(function (p, i) {
          var li = document.createElement('li');
          var already = state.handles.indexOf(p.handle) !== -1;
          li.innerHTML = '<button type="button" class="cc-result" role="option" data-index="' + i + '"' + (already ? ' disabled' : '') + '>' +
            '<img src="' + esc(p.image || '') + '" alt="" loading="lazy">' +
            '<span class="cc-result__body"><span class="cc-result__vendor">' + esc(p.vendor || '') + '</span><span class="cc-result__title">' + esc(p.title) + (already ? ' — added' : '') + '</span></span>' +
            '<span class="cc-result__price">' + esc(p.price_formatted || '') + '</span></button>';
          results.appendChild(li);
        });
      }
      results.hidden = false;
      search.setAttribute('aria-expanded', 'true');
    }
    function runSearch(q) {
      if (spinner) spinner.hidden = false;
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,vendor,variants.sku,variants.barcode,tag';
      fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (json) {
          var prods = (json && json.resources && json.resources.results && json.resources.results.products) || [];
          renderResults(prods.map(function (p) {
            return { handle: p.handle, title: p.title, vendor: p.vendor, image: p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || ''), price_formatted: formatMoney(p.price), url: p.url };
          }), q);
        })
        .catch(function () { if (results) { results.innerHTML = '<li class="cc-results__msg">Search is unavailable right now.</li>'; results.hidden = false; } })
        .then(function () { if (spinner) spinner.hidden = true; });
    }
    function formatMoney(v) {
      if (v == null || v === '') return '';
      var n = typeof v === 'number' ? v : parseFloat(v);
      if (isNaN(n)) return String(v);
      var fmt = root.dataset.moneyFormat || '${{amount}}';
      var amount = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount).replace(/<[^>]+>/g, '');
    }
    if (search) {
      search.addEventListener('input', function () {
        clearTimeout(searchTimer);
        var q = search.value.trim();
        if (q.length < 2) { closeResults(); return; }
        searchTimer = setTimeout(function () { runSearch(q); }, 220);
      });
      search.addEventListener('keydown', function (e) {
        if (results.hidden) return;
        var buttons = results.querySelectorAll('.cc-result');
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          activeIndex = e.key === 'ArrowDown' ? Math.min(buttons.length - 1, activeIndex + 1) : Math.max(0, activeIndex - 1);
          buttons.forEach(function (b, i) { b.setAttribute('aria-selected', i === activeIndex ? 'true' : 'false'); });
          if (buttons[activeIndex]) buttons[activeIndex].scrollIntoView({ block: 'nearest' });
        } else if (e.key === 'Enter') {
          if (activeIndex >= 0 && buttons[activeIndex] && !buttons[activeIndex].disabled) { e.preventDefault(); buttons[activeIndex].click(); }
          else if (buttons.length === 1 && !buttons[0].disabled) { e.preventDefault(); buttons[0].click(); }
        } else if (e.key === 'Escape') { closeResults(); }
      });
      document.addEventListener('click', function (e) { if (!e.target.closest('[data-search-wrap]')) closeResults(); });
    }
    root.addEventListener('click', function (e) {
      var r = e.target.closest('.cc-result');
      if (r && !r.disabled) {
        var p = lastResults[parseInt(r.dataset.index, 10)];
        if (p) add(p.handle, { handle: p.handle, title: p.title, vendor: p.vendor, image: p.image, price_formatted: p.price_formatted, url: p.url });
        closeResults();
        if (search) { search.value = ''; search.focus(); }
        return;
      }
      if (e.target.closest('[data-focus-search]')) { if (search) search.focus(); return; }
      var rm = e.target.closest('[data-remove]');
      if (rm) { remove(rm.closest('[data-slot]').dataset.handle); return; }
      if (e.target.closest('[data-clear]')) { state.handles = []; render(); return; }
      if (e.target.closest('[data-print]')) { window.print(); return; }
      var cp = e.target.closest('[data-copy-link]');
      if (cp) {
        var link = location.origin + location.pathname + '?products=' + encodeURIComponent(state.handles.join(','));
        var done = function () { var t = cp.textContent; cp.textContent = 'Link copied ✓'; setTimeout(function () { cp.textContent = t; }, 1800); };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(link).then(done, function () { prompt('Copy this link', link); });
        else prompt('Copy this link', link);
      }
    });
    if (diffOnly && table) diffOnly.addEventListener('change', function () { table.classList.toggle('diff-only', diffOnly.checked); });

    /* ---------- rendering ---------- */
    function render() {
      syncOut();
      /* slots */
      slots.innerHTML = '';
      state.handles.forEach(function (h) {
        var p = state.products[h] || { title: h };
        var el = slotTpl.content.firstElementChild.cloneNode(true);
        el.dataset.handle = h;
        el.querySelector('.cc-slot__img').src = p.image || '';
        el.querySelector('.cc-slot__vendor').textContent = p.vendor || '';
        el.querySelector('.cc-slot__title').textContent = p.title || h;
        el.querySelector('.cc-slot__price').textContent = p.price_formatted || (state.loading[h] ? 'Loading…' : '');
        el.querySelector('[data-remove]').setAttribute('aria-label', 'Remove ' + (p.title || h));
        slots.appendChild(el);
      });
      for (var i = state.handles.length; i < max; i++) slots.appendChild(emptyTpl.content.firstElementChild.cloneNode(true));
      if (slotCount) slotCount.textContent = '(' + state.handles.length + ' of ' + max + ')';
      if (pickerActions) pickerActions.hidden = state.handles.length === 0;
      if (hint) hint.hidden = state.handles.length > 0;

      var ready = state.handles.filter(function (h) { return state.products[h] && !state.products[h]._seed; });
      var anyLoading = state.handles.some(function (h) { return state.loading[h]; });
      if (state.handles.length < 2) {
        area.hidden = true; emptyMsg.hidden = false;
        emptyMsg.textContent = state.handles.length === 1 ? 'Add one more product to start comparing.' : (emptyMsg.dataset.default || (emptyMsg.dataset.default = emptyMsg.textContent));
        return;
      }
      emptyMsg.hidden = true; area.hidden = false;
      if (status) status.textContent = anyLoading ? 'Loading product details…' : ready.length + ' products compared';
      if (ready.length < 2) return;
      buildTable(ready.map(function (h) { return state.products[h]; }));
      var key = ready.join(',');
      if (aiBody && state.aiKey && state.aiKey !== key) { aiBody.hidden = true; aiBody.innerHTML = ''; state.aiKey = ''; }
      state.tableKey = key;
    }

    function buildTable(prods) {
      var n = prods.length;
      /* header */
      var h = '<tr><th scope="col"><span class="visually-hidden">Product</span></th>';
      prods.forEach(function (p) {
        var vid = p.video_id;
        h += '<th scope="col"><div class="cc-prod">' +
          (p.image ? '<img class="cc-prod__img" src="' + esc(p.image) + '" alt="">' : '') +
          '<span class="cc-prod__vendor">' + (p.vendor_logo ? '<img src="' + esc(p.vendor_logo) + '" alt="">' : '') + esc(p.vendor || '') + '</span>' +
          '<span class="cc-prod__title"><a href="' + esc(p.url || '#') + '">' + esc(p.title) + '</a></span>' +
          '<span class="cc-prod__price">' + esc(p.price_formatted || '') + '</span>' +
          '<span class="cc-prod__actions"><a class="cc-chip" href="' + esc(p.url || '#') + '">View</a>' +
          (p.manufacturer_url ? '<a class="cc-chip" href="' + esc(p.manufacturer_url) + '" target="_blank" rel="noopener">Manufacturer ↗</a>' : '') +
          (vid ? '<a class="cc-chip cc-chip--video" href="' + esc(p.video_url) + '" target="_blank" rel="noopener">▶ Video</a>' : '') +
          '</span></div></th>';
      });
      h += '</tr>';
      thead.innerHTML = h;

      var rows = [];
      function section(title) { rows.push('<tr class="cc-section-row"><th scope="row">' + esc(title) + '</th><td colspan="' + n + '"></td></tr>'); }
      function row(label, values, opts) {
        opts = opts || {};
        var norm = values.map(function (v) { return (v == null ? '' : String(v)).trim().toLowerCase(); });
        var present = norm.filter(Boolean);
        if (!present.length) return;
        var same = present.length === n && norm.every(function (v) { return v === norm[0]; });
        var bestIdx = -1, bestLabel = '';
        if (opts.better && !same) {
          var nums = values.map(parseNumber);
          var valid = nums.map(function (x, i) { return x == null ? null : i; }).filter(function (i) { return i != null; });
          if (valid.length >= 2) {
            var pick = valid[0];
            valid.forEach(function (i) { if (opts.better === 'lower' ? nums[i] < nums[pick] : nums[i] > nums[pick]) pick = i; });
            var ties = valid.filter(function (i) { return nums[i] === nums[pick]; });
            if (ties.length === 1) { bestIdx = pick; bestLabel = opts.better === 'lower' ? (opts.bestLabel || 'Lowest') : (opts.bestLabel || 'Highest'); }
          }
        }
        var cells = values.map(function (v, i) {
          var html = opts.html ? v : esc(v);
          if (!norm[i]) return '<td class="is-missing">—</td>';
          return '<td' + (i === bestIdx ? ' class="is-best" data-best-label="' + esc(bestLabel) + '"' : '') + '>' + html + '</td>';
        }).join('');
        rows.push('<tr class="' + (same ? 'is-same' : 'is-diff') + '"><th scope="row">' + esc(label) + '</th>' + cells + '</tr>');
      }

      section('At a glance');
      row('Price', prods.map(function (p) { return p.price_formatted; }), { better: 'lower', bestLabel: 'Lowest price' });
      row('Brand', prods.map(function (p) { return p.vendor; }));
      row('Type', prods.map(function (p) { return p.type; }));
      row('Category', prods.map(function (p) { return [p.top_level, p.sub_filter].filter(Boolean).join(' › '); }));
      row('SKU', prods.map(function (p) { return p.sku; }));
      row('Shipping weight', prods.map(function (p) { return p.weight_grams ? (Math.round(p.weight_grams / 453.592 * 10) / 10) + ' lb (' + (Math.round(p.weight_grams / 100) / 10) + ' kg)' : ''; }), { better: 'lower', bestLabel: 'Lightest' });

      var anyBest = prods.some(function (p) { return p.parsed.bestFor; });
      if (anyBest) { section('Best for'); row('Best for', prods.map(function (p) { return p.parsed.bestFor; })); }

      var anyOverview = prods.some(function (p) { return p.parsed.overview; });
      if (anyOverview) { section('Overview'); row('Overview', prods.map(function (p) { return p.parsed.overview; })); }

      var anyHl = prods.some(function (p) { return p.parsed.highlights.length; });
      if (anyHl) {
        section('Highlights');
        row('Highlights', prods.map(function (p) { return p.parsed.highlights.length ? '<ul class="cc-list">' + p.parsed.highlights.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul>' : ''; }), { html: true });
      }

      /* specs: union of labels in order of first appearance */
      var labels = [];
      var seen = {};
      prods.forEach(function (p) { p.parsed.specs.forEach(function (sp) { var k = sp[0].toLowerCase(); if (!seen[k]) { seen[k] = sp[0]; labels.push(k); } }); });
      if (labels.length) {
        section('Key specs');
        labels.forEach(function (k) {
          var vals = prods.map(function (p) { var hit = p.parsed.specs.filter(function (sp) { return sp[0].toLowerCase() === k; })[0]; return hit ? hit[1] : ''; });
          var better = LOWER_BETTER.test(k) ? 'lower' : (HIGHER_BETTER.test(k) ? 'higher' : null);
          if (/zoom|range|angle|pan|tilt|dimensions|size|channels|dmx/i.test(k)) better = null;
          row(seen[k], vals, { better: better, bestLabel: better === 'lower' ? 'Lowest' : 'Highest' });
        });
      }
      /* other sections */
      var extraKeys = [];
      var extraSeen = {};
      prods.forEach(function (p) { Object.keys(p.parsed.sections).forEach(function (k) { if (!extraSeen[k]) { extraSeen[k] = 1; extraKeys.push(k); } }); });
      if (extraKeys.length) {
        section('More details');
        extraKeys.forEach(function (k) { row(k, prods.map(function (p) { return p.parsed.sections[k] || ''; })); });
      }
      var anyNotes = prods.some(function (p) { return p.parsed.notes.length; });
      if (anyNotes) row('Notes', prods.map(function (p) { return p.parsed.notes.join(' '); }));

      section('Links');
      row('Product page', prods.map(function (p) { return '<a class="cc-link" href="' + esc(p.url) + '">' + esc(p.title) + '</a>'; }), { html: true });
      if (prods.some(function (p) { return p.manufacturer_url; })) row('Manufacturer', prods.map(function (p) { return p.manufacturer_url ? '<a class="cc-link" href="' + esc(p.manufacturer_url) + '" target="_blank" rel="noopener">' + esc(p.manufacturer_url.replace(/^https?:\/\/(www\.)?/, '').split('/')[0]) + ' ↗</a>' : ''; }), { html: true });
      if (prods.some(function (p) { return p.video_url; })) row('Video', prods.map(function (p) { return p.video_url ? '<a class="cc-link" href="' + esc(p.video_url) + '" target="_blank" rel="noopener">Watch on YouTube ↗</a>' : ''; }), { html: true });

      tbody.innerHTML = rows.join('');
    }

    /* ---------- AI ---------- */
    var loadingMsgs = ['Reading the spec sheets…', 'Lining up the numbers…', 'Weighing the trade-offs…', 'Writing it up in plain English…'];
    function renderAi(result) {
      if (!result) { aiBody.innerHTML = '<div class="cc-ai__error">The AI service returned an empty answer. Please try again.</div>'; return; }
      if (typeof result === 'string') { aiBody.innerHTML = '<div class="cc-ai__md">' + mdToHtml(result) + '</div>'; return; }
      var html = '';
      if (result.summary) html += '<p class="cc-ai__summary">' + esc(result.summary) + '</p>';
      if (Array.isArray(result.products) && result.products.length) {
        html += '<div class="cc-ai__grid">' + result.products.map(function (p) {
          return '<div class="cc-ai__card"><h3>' + esc(p.title || p.name || '') + '</h3>' +
            (p.best_for ? '<span class="cc-ai__best">Best for: ' + esc(p.best_for) + '</span>' : '') +
            (Array.isArray(p.pros) && p.pros.length ? '<h4>Strengths</h4><ul>' + p.pros.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul>' : '') +
            (Array.isArray(p.cons) && p.cons.length ? '<h4 class="is-con">Trade-offs</h4><ul>' + p.cons.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul>' : '') +
            '</div>';
        }).join('') + '</div>';
      }
      if (Array.isArray(result.differences) && result.differences.length) {
        html += '<div class="cc-ai__diffs"><h3>Key differences</h3><ul>' + result.differences.map(function (d) {
          if (typeof d === 'string') return '<li>' + esc(d) + '</li>';
          return '<li><strong>' + esc(d.aspect || '') + (d.aspect ? ': ' : '') + '</strong>' + esc(d.detail || '') + '</li>';
        }).join('') + '</ul></div>';
      }
      if (result.recommendation) html += '<div class="cc-ai__verdict"><h3>Our take</h3><p>' + esc(result.recommendation) + '</p></div>';
      if (!html && result.markdown) html = '<div class="cc-ai__md">' + mdToHtml(result.markdown) + '</div>';
      aiBody.innerHTML = html || '<div class="cc-ai__error">The AI service returned an unexpected answer.</div>';
    }
    function mdToHtml(md) {
      var lines = String(md).split(/\r?\n/), out = [], inList = false;
      lines.forEach(function (l) {
        var t = l.trim();
        if (!t) { if (inList) { out.push('</ul>'); inList = false; } return; }
        var inline = esc(t).replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
        if (/^#{1,3}\s/.test(t)) { if (inList) { out.push('</ul>'); inList = false; } out.push('<h3>' + inline.replace(/^#{1,3}\s/, '') + '</h3>'); }
        else if (/^[-*]\s/.test(t)) { if (!inList) { out.push('<ul>'); inList = true; } out.push('<li>' + inline.replace(/^[-*]\s/, '') + '</li>'); }
        else { if (inList) { out.push('</ul>'); inList = false; } out.push('<p>' + inline + '</p>'); }
      });
      if (inList) out.push('</ul>');
      return out.join('');
    }
    if (aiRun && aiBody && endpoint) {
      aiRun.addEventListener('click', function () {
        var prods = state.handles.map(function (h) { return state.products[h]; }).filter(function (p) { return p && !p._seed && !p._error; });
        if (prods.length < 2) { aiBody.hidden = false; aiBody.innerHTML = '<div class="cc-ai__error">Wait for the product details to load, then try again.</div>'; return; }
        var payload = {
          shop: 'Creative Stage Lighting',
          products: prods.map(function (p) {
            var specs = {};
            p.parsed.specs.forEach(function (sp) { if (sp[0]) specs[sp[0]] = sp[1]; });
            return { handle: p.handle, title: p.title, vendor: p.vendor, type: p.type, category: [p.top_level, p.sub_filter].filter(Boolean).join(' › '), price: p.price_formatted, price_cents: p.price, overview: p.parsed.overview, best_for: p.parsed.bestFor, highlights: p.parsed.highlights, specs: specs, notes: p.parsed.notes, url: location.origin + (p.url || '') };
          })
        };
        aiRun.disabled = true;
        aiBody.hidden = false;
        state.aiKey = state.tableKey || prods.map(function (p) { return p.handle; }).join(',');
        var mi = 0;
        aiBody.innerHTML = '<div class="cc-ai__loading"><i></i><span data-msg>' + loadingMsgs[0] + '</span></div>';
        var ticker = setInterval(function () { mi = (mi + 1) % loadingMsgs.length; var m = aiBody.querySelector('[data-msg]'); if (m) m.textContent = loadingMsgs[mi]; }, 2200);
        var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
        var timeout = setTimeout(function () { if (ctrl) ctrl.abort(); }, 90000);
        fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload), signal: ctrl ? ctrl.signal : undefined })
          .then(function (r) { return r.text().then(function (t) { var j = null; try { j = JSON.parse(t); } catch (e) { /* not json */ } if (!r.ok) throw new Error((j && (j.error || j.message)) || ('The AI service answered with HTTP ' + r.status)); return j || { result: t }; }); })
          .then(function (j) { renderAi(j.comparison || j.result || j); })
          .catch(function (err) { aiBody.innerHTML = '<div class="cc-ai__error">Couldn’t generate the comparison: ' + esc(err && err.message ? err.message : 'network error') + '</div>'; })
          .then(function () { clearInterval(ticker); clearTimeout(timeout); aiRun.disabled = false; });
      });
    }

    /* ---------- boot ---------- */
    var initial = fromUrl();
    if (!initial || !initial.length) initial = readStore().map(function (p) { return p.handle; }).slice(0, max);
    state.handles = initial.filter(Boolean);
    render();
    state.handles.forEach(load);
    window.addEventListener('storage', function (e) {
      if (e.key !== STORAGE_KEY) return;
      var list = readStore().map(function (p) { return p.handle; }).slice(0, max);
      if (list.join() !== state.handles.join()) { state.handles = list; render(); list.forEach(load); }
    });
  }

  function boot() { document.querySelectorAll('[data-cc]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var el = e.target && e.target.querySelector && e.target.querySelector('[data-cc]'); if (el) { delete el.dataset.ccReady; init(el); } });
})();
